import { ButtonColor } from "@/common/enum/button-color";
import { Button } from "flowbite-react";
import { Footnote12Description } from "../typography/Footnote12Description";

interface Props {
  color: ButtonColor;
  children: React.ReactNode;
  textColor?: string;
  className?: string;
}

export const StatusButton: React.FC<Props> = ({
  color,
  children,
  textColor,
  className,
}) => {
  return (
    <Button
      color={color}
      size="xs"
      className={`flex justify-center items-center p-0 pointer-events-none cursor-not-allowed ${className}`}
    >
      <Footnote12Description className={"mt-[2px] " + textColor}>
        {children}
      </Footnote12Description>
    </Button>
  );
};
